import { render, staticRenderFns } from "./posterManage.vue?vue&type=template&id=c9e2a58a&scoped=true&"
import script from "./posterManage.vue?vue&type=script&lang=js&"
export * from "./posterManage.vue?vue&type=script&lang=js&"
import style0 from "./posterManage.vue?vue&type=style&index=0&id=c9e2a58a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e2a58a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9e2a58a')) {
      api.createRecord('c9e2a58a', component.options)
    } else {
      api.reload('c9e2a58a', component.options)
    }
    module.hot.accept("./posterManage.vue?vue&type=template&id=c9e2a58a&scoped=true&", function () {
      api.rerender('c9e2a58a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/posterManage/posterManage.vue"
export default component.exports